import React from "react";
import LivesCovered from "./Components/LivesCovered";
import Premiums from "./Components/Premiums";
import Benefits from "./Components/Benefits";

const MalipowwsConfigs = (props) => {
  return (
    <>
      <LivesCovered
        membership_configs={props.membership_configs}
        productGuid={props.productGuid}
        lives_covered={props.lives_covered}
        extendedConfig={props.extendedConfig}
      />

      <Premiums
        membership_configs={props.membership_configs}
        productGuid={props.productGuid}
        premiums={props.premiums || []}
        extendedConfig={props.extendedConfig}
      />

      <Benefits
        membership_configs={props.membership_configs}
        productGuid={props.productGuid}
        benefits={props.benefits || []}
        extendedConfig={props.extendedConfig}
      />
    </>
  );
};

export default MalipowwsConfigs;
